import { render, staticRenderFns } from "./createSenderBanner.vue?vue&type=template&id=57e08786"
import script from "./createSenderBanner.vue?vue&type=script&lang=js"
export * from "./createSenderBanner.vue?vue&type=script&lang=js"
import style0 from "./createSenderBanner.vue?vue&type=style&index=0&id=57e08786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports